import ProductsResult from './ResultPage';

export default ProductsResult;
